import React from "react";
import ShareBtn from '../assets/Share-btn.png';
import StandLine from '../assets/stand-line.png';
import FromToTrip from '../assets/from-to-trip.png';
import { Link } from "react-router-dom";
import RightPriceDetailsTabs from "./RightPriceDetailsTabs";
import IsolationMode from "../assets/Isolation_Mode.png";
import IsolationMode01 from "../assets/Isolation_Mode01.png";
import IsolationMode02 from "../assets/Isolation_Mode02.png";
import { useTranslation } from 'react-i18next'

const TripSummary = () => {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-lg-8 col-md-12 mb-4">
        <div className="card-box">
          <div className="share-box-top-trip p-25 border-bottom-box">
            <ul className="d-flex justify-content-between align-items-center gap-2 m-0 p-0 list-unstyled">
              <li>
                <h4 className="m-0 p-0">{t("tripSummary")}</h4>
              </li>
              <li>
                <Link to="/" className="btn-btn-share-box">
                  <img src={ShareBtn} alt="share" />
                </Link>
              </li>
            </ul>
          </div>

          <hr className="line-shap m-0 p-0" />

          
            {/* First Segment */}
            <div className="bottom-details-flight-booking p-25">
              <h3>
                {t("Indore")} <span>→</span> {t("New Delhi")}
              </h3>

              {/* First Segment */}
              <div className="bottom-location-trip d-flex align-items-center gap-2 justify-content-between">
                <div className="left-bottom-location-box d-flex align-items-center gap-lg-4 gap-2">
                  <div className="left-trip-box">
                    <div className="text-bot text-start">
                      <h6>
                        08:05 <span>{t("Tue, 9 Sept")}</span>
                      </h6>
                    </div>
                    <div className="time-mid-box text-end">
                      <span>{t("1h 30m")}</span>
                    </div>
                    <div className="text-bot text-start">
                      <h6>
                        09:35 <span>{t("Tue, 9 Sept")}</span>
                      </h6>
                    </div>
                  </div>
                  <div className="icons-box">
                    <img src={StandLine} alt="stand-line" />
                  </div>
                  <div className="mid-details-box">
                    <div className="text-bot text-start">
                      <h6>
                        {t("Indore")} · {t("IDR")} <span>{t("Devi Ahilya Bai Holkar")}</span>
                      </h6>
                    </div>
                    <div className="time-mid-box text-start d-flex align-items-center gap-1">
                      <img src={FromToTrip} alt="from-to" />
                      <span>{t("Air India Limited")}</span>
                    </div>
                    <div className="text-bot text-start">
                      <h6>
                        {t("New Delhi")} · {t("DEL")} {" "}
                        <span>{t("Indira Gandhi International")}</span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="right-arrow-box">
                  <svg
                    width="20"
                    height="13"
                    viewBox="0 0 20 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L10 10L18 2"
                      stroke="#888888"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>

              <hr className="line-shap" />

            {/* Second Segment */}
            
            <div className="bottom-location-trip d-flex align-items-center gap-2 justify-content-between">
                <div className="left-bottom-location-box d-flex align-items-center gap-lg-4 gap-2">
                  <div className="left-trip-box">
                    <div className="text-bot text-start">
                      <h6>
                        08:05 <span>{t("Tue, 9 Sept")}</span>
                      </h6>
                    </div>
                    <div className="time-mid-box text-end">
                      <span>{t("1h 30m")}</span>
                    </div>
                    <div className="text-bot text-start">
                      <h6>
                        09:35 <span>{t("Tue, 9 Sept")}</span>
                      </h6>
                    </div>
                  </div>
                  <div className="icons-box">
                    <img src={StandLine} alt="stand-line" />
                  </div>
                  <div className="mid-details-box">
                    <div className="text-bot text-start">
                      <h6>
                        {t("Indore")} · {t("IDR")} <span>{t("Devi Ahilya Bai Holkar")}</span>
                      </h6>
                    </div>
                    <div className="time-mid-box text-start d-flex align-items-center gap-1">
                      <img src={FromToTrip} alt="from-to" />
                      <span>{t("Air India Limited")}</span>
                    </div>
                    <div className="text-bot text-start">
                      <h6>
                        {t("New Delhi")} · {t("DEL")} {" "}
                        <span>{t("Indira Gandhi International")}</span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="right-arrow-box">
                  <svg
                    width="20"
                    height="13"
                    viewBox="0 0 20 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L10 10L18 2"
                      stroke="#888888"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
          </div>

        </div>


         <div className="card-box mt-4">
            <div className="share-box-top-trip p-25 border-bottom-box">
                <ul className="d-flex justify-content-between align-items-center gap-2 m-0 p-0 list-unstyled">
                <li>
                <h4 className="m-0 p-0">{t("primaryPassenger")}</h4>
                </li>
                <li>
                    <select className="form-select" aria-label="Default select example">
                      <option defaultValue>{t("adultOver12")}</option>
                      <option value="1">{t("adultOver25")}</option>
                      <option value="2">{t("adultOver50")}</option>
                    </select>
                </li>
                </ul>
            </div>

            <hr className="line-shap m-0 p-0" />

            <div className="form-bottom-trip-box p-25">
                <div className="top-trip-box">
                <p>{t("boardingNote")} <strong>{t("passport")}</strong> </p>
                </div>
                <div className="trip-booking-flight-form">
                <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("givenNames")}</label>
                      <input type="text" className="form-control" placeholder={t("exampleName")} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("surnames")}</label>
                      <input type="text" className="form-control" placeholder={t("exampleSurname")} />
                    </div>
                  </div>

                  {/* Nationality */}
                  <div className="col-md-3">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("nationality")}</label>
                      <select className="form-select">
                        <option defaultValue>{t("select")}</option>
                        <option value="1">{t("select2")}</option>
                        <option value="2">{t("select3")}</option>
                      </select>
                    </div>
                  </div>

                  {/* Gender */}
                  <div className="col-md-3">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("gender")}</label>
                      <select className="form-select">
                        <option defaultValue>{t("select")}</option>
                        <option value="1">{t("male")}</option>
                        <option value="2">{t("female")}</option>
                      </select>
                    </div>
                  </div>

                  {/* Date of birth */}
                  <div className="col-md-6">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("dob")}</label>
                      <div className="dob-box d-flex align-items-center">
                        <input type="text" className="form-control" placeholder={t("day")} />
                        <select className="form-select">
                          <option defaultValue>{t("month")}</option>
                          <option value="1">{t("jan")}</option>
                          <option value="2">{t("feb")}</option>
                          <option value="3">{t("mar")}</option>
                        </select>
                        <input type="text" className="form-control" placeholder={t("year")} />
                      </div>
                    </div>
                  </div>

                  {/* Passport */}
                  <div className="col-md-6">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("passportNumber")}</label>
                      <input type="text" className="form-control" placeholder="XXXXXXXXXXXXXXX" />
                    </div>
                  </div>

                  {/* Expiration */}
                  <div className="col-md-6">
                    <div className="from-group mb-4">
                      <label className="form-label">{t("expirationDate")}</label>
                      <div className="dob-box d-flex align-items-center">
                        <input type="text" className="form-control" placeholder={t("day")} />
                        <select className="form-select">
                          <option defaultValue>{t("month")}</option>
                          <option value="1">{t("jan")}</option>
                          <option value="2">{t("feb")}</option>
                          <option value="3">{t("mar")}</option>
                        </select>
                        <input type="text" className="form-control" placeholder={t("year")} />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 ms-auto">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="noExpiration"/>
                      <label className="form-check-label" htmlFor="noExpiration">
                        {t("noExpiration")}
                      </label>
                    </div>
                  </div>
                </div>
              </form>
                </div>
            </div>

            <div className="baggage-sec p-25">
            <h4 className="m-0 p-0">{t("cabinBaggage")}</h4>
            <div className="baggeg-box text-center p-25 mt-4">
              <h5>{t("carryOnBundle")}</h5>
              <p>{t("carryOnDescription")}</p>
              <ul className="product-list p-0 m-0 list-unstyled d-flex align-items-end justify-content-center gap-2 mt-4"> 
                <li> <img src={IsolationMode} alt="carry item" /> <span> {t("firstproduct")} </span> </li> 
                <li> <img src={IsolationMode01} alt="cabin bag" /> <span>{t("firstproduct")}</span> </li> 
              </ul>
              <div className="include-box d-flex align-items-center justify-content-between gap-2">
                <div className="btn-include d-flex align-items-center gap-2">
                  <span>{t("included")}</span>
                </div>
                <div className="checked-box-item"> <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="10.5" fill="white" stroke="#11621D" /><circle cx="11" cy="11" r="8" fill="#11621D" /></svg> </div>
              </div>
            </div>
          </div>

          <div className="baggage-sec p-25">
            <h4 className="m-0 p-0">{t("checkedBaggage")}</h4>
            <div className="baggeg-box text-center p-25 mt-4">
              <h5>{t("oneCheckedBag")}</h5>
              <p>{t("checkedBagInfo")}</p>
              <ul className="product-list p-0 m-0 list-unstyled d-flex align-items-end justify-content-center gap-2 mt-4"> 
                <li> <img src={IsolationMode02} alt="checked bag" /> <span>{t("secondproduct")}</span> </li> 
              </ul>
              <div className="include-box d-flex align-items-center justify-content-between gap-2">
                <div className="btn-include d-flex align-items-center gap-2">
                  <span>{t("included")}</span>
                </div>
                <div className="checked-box-item"> <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="10.5" fill="white" stroke="#11621D" /><circle cx="11" cy="11" r="8" fill="#11621D" /></svg> </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add passenger */}
        <div className="card-box mt-4">
          <ul className="btn-box-add-bottom d-flex align-items-center gap-2 justify-content-between flex-wrap flex-md-nowrap gap-4 list-unstyled m-0 p-25">
            <li>
              <h4 className="m-0 p-0">{t("bookingMorePassengers")}</h4>
            </li>
            <li>
              <Link to="#" className="btn-btn-orange d-block">
                {t("addPassenger")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="col-lg-4 col-md-12 mb-4">
        <RightPriceDetailsTabs />
      </div>
    </div>
  );
};

export default TripSummary;
